module.exports = __webpack_public_path__ + "static/media/festivals.e7974857.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/festivals.svg
// module id = 276
// module chunks = 0